// extracted by mini-css-extract-plugin
export default {"page__title":"first_page__title__h9CUw","form":"first_form__qtk4B","form__fields":"first_form__fields__jgw76","form__button":"first_form__button__DE95N"};